exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-input[data-v-0814e9ac] {\n    color: #495057;\n    background-color: #fff;\n    background-clip: padding-box;\n    border: 1px solid #ced4da;\n    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n    padding: 0.25rem 0.5rem;\n    font-size: 0.7875rem;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n}\n", ""]);

// exports
